<template>
  <div class="bg-white rounded-[24px] p-4 border border-[#1c4848]/5 shadow-sm flex gap-4">
    <div class="w-24 h-32 rounded-2xl bg-[#1c4848]/10 animate-pulse shrink-0" />
    <div class="flex-1 flex flex-col gap-2 min-w-0">
      <div class="h-4 w-1/3 rounded bg-[#1c4848]/10 animate-pulse" />
      <div class="h-5 w-2/3 rounded bg-[#1c4848]/15 animate-pulse" />
      <div class="h-3 w-full rounded bg-[#1c4848]/10 animate-pulse" />
      <div class="h-3 w-2/3 rounded bg-[#1c4848]/10 animate-pulse mt-auto" />
    </div>
  </div>
</template>

<script setup>
</script>
